/*
 *  Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('PublicFolderLinkResource', [
        '$resource',
        function (
            $resource
        ) {
            function _transformLinkUpdateRequest(publicFolderData) {
                return angular.toJson({
                    allow_downloading: publicFolderData.allow_downloading,
                    access_restriction: publicFolderData.access_restriction,
                    password: publicFolderData.password,
                    expiration_date: publicFolderData.expiration_date
                });
            }

            return $resource('/sync_and_share_nodes/:node_uuid/public_folder_link', {node_uuid: '@node_uuid'}, {
                update: {
                    method: 'PUT',
                    transformRequest: _transformLinkUpdateRequest
                }
            });
        }
    ]);
